export enum Role {
	MANAGER = "manager",
	USER = "user",
	OWNER = "owner",
}
